import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconCamera: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M11.9412 8.52866C11.9412 10.2384 10.5551 11.6243 8.84558 11.6243C7.13604 11.6243 5.75 10.2384 5.75 8.52866C5.75 6.81908 7.13604 5.43317 8.84558 5.43317C10.5551 5.43317 11.9412 6.81908 11.9412 8.52866Z"
        fill={fill}
      />
      <path
        d="M16.23 2.56244H13.2404L12.4366 0.954926C12.1199 0.322118 11.5987 0 10.891 0H6.94106C6.23364 0 5.71238 0.322135 5.39575 0.954926L4.59199 2.56244H1.6024C0.5412 2.56244 0.000976562 3.10266 0.000976562 4.164V13.4529C0.000976562 14.5142 0.5412 15.0544 1.60254 15.0544H16.23C17.2913 15.0544 17.8315 14.5142 17.8315 13.4529V4.164C17.8315 3.10266 17.2913 2.56244 16.23 2.56244ZM8.91626 12.9724C6.41021 12.9724 4.37866 10.941 4.37866 8.43485C4.37866 5.92866 6.41043 3.89725 8.91626 3.89725C11.422 3.89725 13.4538 5.92902 13.4538 8.43485C13.4538 10.9409 11.4219 12.9724 8.91626 12.9724ZM15.6965 5.65908C15.1655 5.65908 14.7352 5.22902 14.7352 4.69821C14.7352 4.1674 15.1655 3.7372 15.6965 3.7372C16.227 3.7372 16.6575 4.16726 16.6575 4.69821C16.6572 5.22874 16.2269 5.65908 15.6965 5.65908Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconCamera;
